import { MenuItem, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { RxTrash } from 'react-icons/rx'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import { DetailedTable, DossTableRow } from '../tables/types'
import { Menu } from '../ui/atoms/menu/Menu'
import { DeleteRecordDialog } from './DeleteRecordDialog'

type ContextMenu = {
  mouseX: number
  mouseY: number
  row: DossTableRow
}

interface ChildTableRecordContextMenuProps {
  contextMenu: ContextMenu
  setContextMenu: (anchorEl: ContextMenu | null) => void
  table: DetailedTable
}

/**
 * Renders context menu for records in a child table
 */
export function ChildTableRecordContextMenu({
  contextMenu,
  setContextMenu,
  table,
}: ChildTableRecordContextMenuProps) {
  const { t } = useTypedTranslation()
  const [openDialog, setOpenDialog] = useState(false)
  const handleCloseMenu = () => {
    setContextMenu(null)
  }

  const handleOpenDeleteRecord = () => {
    setOpenDialog(true)
  }

  const handleCloseDeleteRecord = () => {
    setOpenDialog(false)
    setContextMenu(null)
  }

  return (
    <>
      <Menu
        anchorPosition={{ top: contextMenu.mouseY, left: contextMenu.mouseX }}
        anchorReference="anchorPosition"
        onClose={handleCloseMenu}
        open={true}
      >
        <MenuItem onMouseDown={handleOpenDeleteRecord}>
          <Stack alignItems="center" direction="row" spacing={1}>
            <RxTrash />
            <Typography>{t('table_settings.child_table.delete_record')}</Typography>
          </Stack>
        </MenuItem>
      </Menu>
      <DeleteRecordDialog
        handleCloseDeleteRecord={handleCloseDeleteRecord}
        handleDeleteRow={handleCloseMenu}
        isChildTableRecord={true}
        openDialog={openDialog}
        tableId={table.id}
        tableRow={contextMenu.row}
      />
    </>
  )
}
